<template>
	<div
		class="multi-select-circle"
		:class="{ disabled: disabled }"
		tabindex="0"
		@mousedown.prevent
		@keydown="onKeyDown($event)"
	>
		<svgicon :name="state" :class="{ selected: selected }"></svgicon>
		<div class="circle-layer"></div>
		<label v-if="label" class="body-text-1">{{ label }}</label>
	</div>
</template>
<script>
import '@/components/icons/multiselect-deselected';
import '@/components/icons/multiselect-selected';
import { keyboardKeyEvents } from '@/helpers/constants';

export default {
	props: {
		selected: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		}
	},
	computed: {
		state() {
			return this.selected ? 'multiselect-selected' : 'multiselect-deselected';
		}
	},
	methods: {
		onKeyDown(e) {
			if (e.keyCode == keyboardKeyEvents.ENTER_KEY_CODE) {
				this.$emit('selected');
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.multi-select-circle {
	font-family: 'RobotoRegular';
	font-size: 15px;
	line-height: 23px;
	display: inline-flex;
	align-items: center;
	position: relative;

	.circle-layer {
		width: 22px;
		height: 22px;
		border-radius: 16px;
		background-color: #fff;
		position: absolute;
		left: 1px;
	}

	&.disabled {
		svg {
			fill: $disabled-state;
		}
	}

	svg {
		z-index: 2;
		height: 24px;
		width: 24px;
		margin-right: 16px;
	}

	&:not(.disabled) {
		&:focus,
		&:hover {
			outline: none;
			&:not(.selected) {
				svg {
					fill: $hover-state;
				}
			}
		}
		&:hover {
			cursor: pointer;
			label {
				cursor: pointer;
			}
		}
		svg {
			fill: $checkbox-icon-color;

			&.selected {
				fill: $icon-color;
			}
		}
	}
}
</style>
